export const selectThermo = ({ thermo }) => thermo;

export const selectThermoSettings = ({ thermo }) => thermo.settings || {};
